import React, { useState } from "react";
import MenuLegged from "../header/Menu";
import Footer from "../footer/Footer";
import Breadcrumb from "../breadcrumb/breadcrumb";
import { FaHome } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import Sidebar from "./sidebar/sidebar"; 
import styles from "./layouts.module.css";

const LabManagement = () => {
  const { section, subsection, action } = useParams();
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "สำหรับผู้ดูแลห้องปฏิบัติการ", url: "" },
    ...(section === "inputdata"
      ? [{ name: "ข้อมูลผลการตรวจ", url: "/inputdata" }]
      : section === "inspection-guide"
      ? [{ name: "แนวทางการตรวจ", url: "/laboratory/inspection-guide" }]
      : section === "document"
      ? [{ name: "เอกสารที่เกี่ยวข้อง", url: "/laboratory/document" }]
      : section === "upload-excel-results"
      ? [{ name: "ขั้นตอนการนำเข้าไฟล์ข้อมูลผลการตรวจ", url: "/laboratory/upload-excel-results" }]
      : section === "add-individual-data"
      ? [{ name: "ลงข้อมูลรายบุคคล", url: "/laboratory/add-individual-data" }]
      : [{ name: "ไม่พบเมนู", url: "/" }]), 
  ];

  return (
    <>
   
      <div className={styles.Breadcrumb}>
        <Breadcrumb pathItems={pathItems} />
      </div>

      <div className={`${styles.Sidebar} layout-page`}>
        <div style={{ display: "flex" }}>
          <Sidebar
            role={"hospital"}
            page={section}
            subsection={subsection}
            action={action}
          />
        </div>
      </div>

    </>
  );
};

export default LabManagement;
